import { useState, useRef, useEffect } from 'react';
import { APIConstants } from '../constants/api';
import useApi from "./useApi";

function useBlobStorage () {
    const [uploadedFiles, setUploadedFiles] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const uploadFormFilesApi = useApi('blobstorage/UploadFormFilesBlob');
    const uploadFormFilesLoad = useRef(true);

    useEffect(() => {
        if (uploadFormFilesLoad.current) {
            uploadFormFilesLoad.current = false;
            return;
        }

        setUploadedFiles(uploadFormFilesApi.data);
        setLoading(uploadFormFilesApi.loading);
        setError(uploadFormFilesApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadFormFilesApi]);

    const uploadFormFilesBlob = async (files) => {
        setLoading(true);
        const formData = new FormData();

        for (const file of files) {
            if (file instanceof Blob) {
                formData.append("files", file, file.name);
            } else {
                formData.append("files", file);
            }
        }

        uploadFormFilesApi.post(formData, {headers: {'Accept': 'multipart/form-data'}});
    }

    const getUploadedFileUrl = (uploadedFile) => {
        return `/${APIConstants.URLS.BASE}/blobstorage/${uploadedFile}`;
    }

    return {
        uploadedFiles,
        error,
        loading,
        uploadFormFilesBlob,
        getUploadedFileUrl
    };
}

export default useBlobStorage;